import { Box, Dialog, DialogActions, Typography } from "@mui/material"
import { useObservable } from "src/framework/store/storeUtil"
import { setServicoCodeModalStatus } from "src/store/vendas/projetos/actions"
import { authUser$ } from "src/framework/components/navigations/MenuUser"
import { ServicoCodeModalContent, ServicoCodeModalTitle } from "src/components/projetos/containers/ServicoCodeModal"
import { SelectCodigoServico } from "src/components/configuracao/ConfiguracaoRevendaForm/container/SelectCodigoServico"
import { useEffect, useState } from "react"
import { notifierStore } from "src/framework/store/NotifierStore"
import { ContaProvider } from "src/providers/cadastros/ContaProvider"
import { FlatButton } from "src/framework/components/buttons/FlatButton"
import { modelCodigoServicoOpen$ } from "src/framework/store/ApiEvents"

const contaProvider = new ContaProvider();

export function ModalCodigoServicoInicial(){
  const authUser = useObservable(authUser$)

  const [codigoServicoLocal, setCodigoServicoLocal] = useState('')

  useEffect(()=>{
    modelCodigoServicoOpen$.next(true)
  },[])

  useEffect(()=>{
    return () => modelCodigoServicoOpen$.next(false)
  },[])

  return (
    <Dialog
        open={true}
        onClose={() => setServicoCodeModalStatus(false)}
      >
        <ServicoCodeModalTitle />

        <ServicoCodeModalContent>
          <Typography variant='body2' color='textSecondary' align="left">
            Após salvar essa informação, ela poderá ser alterada novamente no menu <strong>Configurações</strong>.
          </Typography>

          <Box style={{ marginTop: 10, marginBottom: 10 }}>
            <SelectCodigoServico
              codigoServico={codigoServicoLocal}
              onChangeCodigoServico={value => setCodigoServicoLocal(value || "")}
            />
          </Box>

          <Typography variant='body2' color='textSecondary' align="left">
            <strong>Caso tenha dúvidas, entre em contato com a equipe Comercial.</strong>
          </Typography>
        </ServicoCodeModalContent>

        <DialogActions>
          <FlatButton
            onClick={() => {
              contaProvider.patchCodigoServico({
                codigo_servico: codigoServicoLocal
              }).then(() => {
                const authUserLocal = { ...authUser, codigo_servico_conta: codigoServicoLocal };
                authUser$.next(authUserLocal);
              }).catch(err => {

                notifierStore.setNotifier({
                  content: ["Erro ao atualizar codigo de serviço."],
                  title: 'Atenção !',
                  timeOut: 4000,
                  onClose: () => notifierStore.setOpen(false),
                });

                notifierStore.setOpen(true);
              })

            }}
            color="primary"
            disabled={!codigoServicoLocal}
            variant="contained"
            text={'Salvar'}
          ></FlatButton>
        </DialogActions>
      </Dialog>
  )
}
